document.querySelector('.topnav').addEventListener('mouseover', function(evt) {
    if (evt.target.tagName !== 'BUTTON') {
        return;
    }
    document.querySelectorAll('.topnav button').forEach(function(elm) {
        elm.blur();
    });
});


document.getElementById('list_subscribe') && document.getElementById('list_subscribe').addEventListener('submit', function(evt) {
    evt.preventDefault();

    let button = evt.target.querySelector('button');
    let pendingElm = evt.target.closest('footer').querySelector('.pending');
    let successElm = evt.target.closest('footer').querySelector('.success');
    let errorElm = evt.target.closest('footer').querySelector('.error');
    let email = evt.target.querySelector('input').value;

    button.setAttribute('disabled', 'disabled');
    pendingElm.classList.remove('hidden');
    successElm.classList.add('hidden');
    errorElm.classList.add('hidden');

    fetch('/api/list-subscribe', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
    })
        .then(response => {
            if (response.status === 201) {
                successElm.querySelector('span').innerText = email;
                pendingElm.classList.add('hidden');
                successElm.classList.remove('hidden');
            } else {
                throw new Error();
            }
        })
        .catch(error => {
            pendingElm.classList.add('hidden');
            errorElm.classList.remove('hidden');
        })
        .finally(() => {
            button.removeAttribute('disabled');
        })
})
